import { Table, TableProps } from './Table'
import { Theme, makeStyles } from '@forgeglobal/design-framework'
import React, { ReactNode } from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  tableWrapper: {
    flexGrow: 1,
    display: 'flex',
    maxWidth: '100vw', // don't overflow horizontally on mobile
    position: 'relative',
    flexDirection: 'column',
  },
}))

export const FullscreenTable = ({ ...rest }: TableProps & { children: ReactNode }) => {
  const styles = useStyles()

  return (
    <div className={styles.wrapper}>
      <Table className={styles.tableWrapper} isFullScreen {...rest} />
    </div>
  )
}
